export {
  erstgespraechTabs,
  avgsTabs,
  bewilligungTabs,
  vertragTabs,
  ecnTabs,
  abschlussTabs,
  avgsForm,
  traegerbestaetigungForm,
} from '@/variants/azav/templates'
export {
  vergabeVerbisTabs,
  vergabeAufnahmePotenzialanalyseTabs,
  vergabeKompetenzfeststellungTabs,
  vergabeKompetenzbilanzierungTabs,
  aufgabeDokumentationForm,
} from '@/variants/vergabe/templates'

import personalTabsJson from './personal-tabs.json'
import portalTabsJson from './portal-tabs.json'
import orgSettingsTabsJson from './orgsettings-tabs.json'
import iconsJson from 'admination-design-system/assets/icons.json'

import type {
  TabsConfig,
  IconRegistry,
} from './types'

export const personalTabs = (personalTabsJson as TabsConfig).tabs
export const portalTabs = (portalTabsJson as TabsConfig).tabs
export const orgSettingsTabs = (orgSettingsTabsJson as TabsConfig).tabs
export const icons = iconsJson as IconRegistry

export { default as stammdatenForm } from './stammdaten'
export { default as memberDetailsForm } from './member-details'
export { default as inviteCoachForm } from './invite-coach'
export { default as teilnehmerDetailsForm } from './teilnehmer-details'
